// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reference-container{padding:1.5rem;background-color:#fff}.reference-container .reference-content{margin:auto;max-width:960px}.reference-container .text__topic-title{font-size:27px;font-weight:700}.reference-container .text__topic-content{line-height:1.6}.reference-container .no-content{text-align:center;color:#6c757d;padding:2rem}", ""]);
// Exports
module.exports = exports;
